import { SideFiltersState } from "@state/reducers/side-filters/SideFiltersReducer";
import { PagesConfig } from "./pageConfig/PagesConfigContext";
import { cloneDeep } from "lodash";
import { addToUpdateFilter, constructCountryFilter, getCurrencyBySelectedCountry, getFiltersInitialState, getInitialAppliedCountries } from "./FilterUtils";
import { FilterKeys, PageType } from "./pageConfig/Types";
import { ProductType } from "@pages/product-analyzer/Product";

/** Initialize base filters for the page */
export const initialiseBaseFilters = (
  pagesConfig: PagesConfig,
  productType: ProductType,
  updateSideFilters: (payload: SideFiltersState) => (dispatch: any) => void,
  pageType: PageType, // dynamic page type
) => {
  const {
    selectedFilters,
    setSelectedFilters,
    appliedFilters,
    setAppliedFilters,
  } = pagesConfig;

  // Find page-specific entry in appliedFilters, fallback to empty if not found
  const pageEntry =
    cloneDeep(appliedFilters.find((af) => af.pageType === pageType)) ?? {
      pageType,
      selectedFilters: [],
    };

  // Extract existing applied values
  const appliedCountry = getFiltersInitialState(
    pageEntry.selectedFilters,
    FilterKeys.COUNTRY,
  );
  const appliedCurrency = getFiltersInitialState(
    pageEntry.selectedFilters,
    FilterKeys.CURRENCY,
  );

  // If both country and currency exist, return them directly
  if (appliedCountry?.options?.length && appliedCurrency?.options?.length) {
    return {
      defaultCountry: appliedCountry.options,
      defaultCurrency: appliedCurrency.options,
    };
  }

  // Construct default filters if missing
  const toUpdateCountryFilter = constructCountryFilter(
    getInitialAppliedCountries(pagesConfig, pageType, productType),
  );
  const toUpdateCurrencyFilter = getCurrencyBySelectedCountry(
    pagesConfig,
    toUpdateCountryFilter.options[0],
  );

  // Clone filters to avoid mutation
  const selectedFiltersClone = cloneDeep(selectedFilters);
  const appliedFiltersClone = cloneDeep(appliedFilters);

  // Update selected filters
  const newSelectedFilters = addToUpdateFilter(
    addToUpdateFilter(selectedFiltersClone, pageType, toUpdateCountryFilter),
    pageType,
    toUpdateCurrencyFilter,
  );
  setSelectedFilters(newSelectedFilters);

  // Update applied filters
  const newAppliedFilters = addToUpdateFilter(
    addToUpdateFilter(appliedFiltersClone, pageType, toUpdateCountryFilter),
    pageType,
    toUpdateCurrencyFilter,
  );
  setAppliedFilters(newAppliedFilters);

  // Update side filters tray
  updateSideFilters({ appliedFilters: newAppliedFilters });

  return {
    defaultCountry: toUpdateCountryFilter.options,
    defaultCurrency: toUpdateCurrencyFilter.options,
  };
};
